module.exports = __webpack_public_path__ + "static/img/4.8dcd0c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/4.png
// module id = 8guu
// module chunks = 0